import { render, staticRenderFns } from "./key-pairs.vue?vue&type=template&id=318fc3aa&"
import script from "./key-pairs.vue?vue&type=script&lang=js&"
export * from "./key-pairs.vue?vue&type=script&lang=js&"
import style0 from "./key-pairs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports